<app-dialog-base titleTranslationKey="file-upload.dialog.title">
  <ng-container content="">
    <p *ngIf="validationError" class="error-box">{{ validationError.translationKey | translate: validationError.interpolateParams }}</p>

    <div class="upload-container" appDragAndDrop (fileDropped)="uploadFileList($event)">
      <p>{{ 'file-upload.drag-and-drop-info.text' | translate }}</p>
      <mat-icon svgIcon="upload" color="primary" />
    </div>
  </ng-container>

  <ng-container actions>
    <input hidden type="file" #fileInput [attr.multiple]="data.multiple ? 'multiple' : null" (change)="uploadFiles($event)" />
    <input hidden type="file" webkitdirectory="true" #directoryInput (change)="uploadFiles($event)" />

    <button *ngIf="data.multiple" mat-stroked-button color="primary" (click)="directoryInput.click()">{{ 'file-upload.dialog.folder-action' | translate }}</button>
    <button mat-flat-button color="primary" (click)="fileInput.click()" cdkFocusInitial>{{ 'file-upload.dialog.action' | translate }}</button>
  </ng-container>
</app-dialog-base>
